import { AxiosError } from 'axios';
import { z } from 'zod';

import { FinancialFormSchema } from '@/components/forms/schemas/FinancialFormSchema';
import { OtherFinancialFormSchema } from '@/components/forms/schemas/OtherFinancialFormSchema';
import { ZEE_FINANCIAL_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

import { GetZeeFinancialApiResponse } from './getZeeFinancial';

export type CreateZeeFinancialApiPayload = z.infer<
  typeof FinancialFormSchema
> & {
  other_financial: z.infer<typeof OtherFinancialFormSchema>;
};

export const createZeeFinancial = async (
  payload: CreateZeeFinancialApiPayload
): Promise<ApiResponse<GetZeeFinancialApiResponse>> => {
  try {
    const response = await apiManager.post(ZEE_FINANCIAL_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
